import { Navigate, useParams } from "react-router-dom";

export function LegacyMyOpportunityRedirect() {
  const { opportunityId } = useParams();
  if (!opportunityId) return null;
  return <Navigate to={`/selling/opportunities/${opportunityId}`} replace />;
}
